import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, change, FieldArray } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';

import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import { sortAlphaNum } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

import MenuItem from 'material-ui/MenuItem';
import { TextField as MUITextField } from 'redux-form-material-ui';
import NoticeEffectiveDateFields from './NoticeEffectiveDateFields';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import MultiFileDropzone from 'components/shared/MultiFileDropzone';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import NoticeAssignmentForm from './NoticeAssignmentForm';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import {
  NoticeTypes,
  LegalNotice,
  NoticeOfEntryNotice,
  legalNoticeAcceptedFileTypes,
} from './constants';

const styles = {
  sectionHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
    marginBottom: '10px',
  },
  fieldsRow: {
    marginBottom: '15px',
    marginTop: '15px',
  },
  imageField: {
    border: `1px dashed ${colors.LIGHT_GRAY}`,
    width: '60%',
    margin: 'auto',
    textAlign: 'center',
  },
};

const config = {
  TOTAL_FILE_SIZE: 15 * 1000000, // 15mb
  IMAGE_SIZE: 3 * 1000000,
};

const cannotBeGreater = (value, allFields) =>
  validator.greaterThan(value, allFields, 'post_date', 'expiryPostDate');

class NoticeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTemplate: { value: 'none', label: 'None' },
      showEffectiveDate: false,
      isTemplate: false,
      isUrgentTemplate: false,
    };
  }

  _postDateIsPresent = () => {
    const { initialValues } = this.props;
    return initialValues && initialValues.post_date ? true : false;
  };

  onTemplateSelect = (event, selectedItem) => {
    this.setState({
      isTemplate: false,
      isUrgentTemplate: false,
    });
    this.props.changeFormValue(this.props.formName, 'effective_dates', null);
    this.props.changeFormValue(this.props.formName, 'attach_management_contact', false);
    this.props.changeFormValue(this.props.formName, 'notice_template_id', null);
    this.props.changeFormValue(this.props.formName, 'properties', []);
    this.props.changeFormValue(this.props.formName, 'image', null);
    this.props.changeFormValue(this.props.formName, 'attachments', []);

    const template = this.props.noticeTemplates.find((template) => template.id === selectedItem);
    if (template) {
      ['name', 'description', 'image', 'attachments'].forEach((key) => {
        if (template[`notice_${key}`]) {
          this.props.changeFormValue(this.props.formName, key, template[`notice_${key}`]);
        }
      });
      this.props.changeFormValue(this.props.formName, 'notice_template_id', template.id);
      this.props.changeFormValue(this.props.formName, 'notice_type', template.notice_type);
      this.setState({
        isTemplate: true,
        isUrgentTemplate: template['urgent'],
      });
    }
  };

  isTemplate = () => {
    const { notice_template_id } = this.props;

    if (notice_template_id && notice_template_id !== 'none') return true;
    return false;
  };

  isUrgentTemplate = () => {
    const { notice_template_id } = this.props;

    let isUrgent = false;
    if (notice_template_id && notice_template_id !== 'none') {
      const template = this.props.noticeTemplates.find(
        (template) => template.id === notice_template_id
      );
      if (template && template.urgent) {
        isUrgent = true;
      }
    }

    return this.state.isUrgentTemplate || isUrgent;
  };

  getSelectedTemplateValue = (key, fallback) => {
    // Get a value from the the template that is currently active
    const template = this.getSelectedTemplate();
    if (template && key in template) {
      return template[key];
    }

    return fallback;
  };

  getSelectedTemplate = () => {
    // If the template is there, return it!!
    const { notice_template_id } = this.props;
    if (notice_template_id && notice_template_id !== 'none') {
      return this.props.noticeTemplates.find((template) => template.id === notice_template_id);
    }
    return undefined;
  };

  getNoticeTemplates = () => {
    let templates = [];
    if (!this.props.canOnlySendByNoticeTemplate) {
      templates = [
        {
          label: getTranslatedString('landlordPortal.noticeForm.none'),
          value: 'none',
        },
      ];
    }
    if (this.props.noticeTemplates && this.props.noticeTemplates.length > 0) {
      let sortedTemplates = this.props.noticeTemplates.sort((a, b) =>
        sortAlphaNum(a['label'], b['label'])
      );
      templates = [...templates, ...sortedTemplates];
    }
    return templates;
  };

  render() {
    const showOptions =
      !!this.props.isNoticeDrawer ||
      !this.props.canOnlySendByNoticeTemplate ||
      this.state.isTemplate;

    return (
      <form onSubmit={this.props.handleSubmit}>
        {this._renderTemplate()}
        {showOptions && this._renderType()}
        {showOptions && this._renderDelivery()}
        {showOptions && this._renderDetails()}
        {showOptions && this._renderEffectiveDate()}
        {showOptions && this._renderAttachments()}
        {showOptions && this._renderPhoto()}
      </form>
    );
  }

  _renderTemplate = () => {
    const isUrgentTemplate = this.isUrgentTemplate();
    const templateDelivery = this.getSelectedTemplateValue('delivery', 'any');
    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.noticeForm.fromTemplateOptionalUpcase')}{' '}
              {!this.props.canOnlySendByNoticeTemplate
                ? getTranslatedString('landlordPortal.noticeForm.optionalUpcase')
                : null}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <Field
              name="notice_template_id"
              component={SelectField}
              onChange={this.onTemplateSelect}
              validate={[validator.required]}
              floatingLabelText={getTranslatedString('landlordPortal.noticeForm.template')}
              fullWidth
              style={{
                marginTop: '-15px',
                fontSize: '15px',
                textAlign: 'left',
                width: '100%',
              }}
              disabled={this.props.readOnly}
            >
              {this.getNoticeTemplates().map((template) => (
                <MenuItem
                  value={template.value}
                  key={template.value}
                  primaryText={template.label}
                />
              ))}
            </Field>
          </div>
          {this._renderWarning(isUrgentTemplate, templateDelivery)}
        </div>
      </Fragment>
    );
  };

  _renderDelivery = () => {
    const { readOnly, form, notice_type } = this.props;

    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.deliveryUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <NoticeAssignmentForm
            noticeType={notice_type}
            formName={form}
            readOnly={readOnly}
            templateDelivery={this.getSelectedTemplateValue('delivery', 'any')}
            shouldFilterProperties={this.getSelectedTemplateValue('assign_to_properties', false)}
            filteredProperties={this.getSelectedTemplateValue('properties', [])}
            isTemplate={this.isTemplate()}
          />
          <div style={{ marginTop: '10px' }}>
            <div className="col-sm-12" style={{ margin: '20px 0px' }}>
              <Field
                name="post_date"
                component={DatePickerAccessible}
                showTimeSelect
                fullWidth
                validate={[validator.required]}
                dateFormat="Pp"
                textFieldStyle={{ width: '100%', fontSize: '14px' }}
                label={getTranslatedString('landlordPortal.noticeForm.postDate')}
                disabled={readOnly || this._postDateIsPresent()}
              />
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className="col-sm-12" style={{ margin: '20px 0px' }}>
              <Field
                name="expiration_date"
                component={DatePickerAccessible}
                showYearDropdown
                showMonthDropdown
                peekNextMonth
                validate={cannotBeGreater}
                formatDate={formatter.reformatDate}
                autoOk={true}
                textFieldStyle={{ width: '100%', fontSize: '14px' }}
                label={getTranslatedString('landlordPortal.noticeForm.expiryDate')}
                disabled={readOnly}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  _renderDetails = () => {
    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.noticeDetailsUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <Field
              name="name"
              component={TextField}
              label={getTranslatedString('landlordPortal.noticeForm.title')}
              validate={[validator.required]}
              disabled={this.props.readOnly || this.isTemplate()}
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <Field
              name="description"
              multiLine
              rows={3}
              fullWidth
              component={MUITextField}
              floatingLabelText={getTranslatedString('landlordPortal.noticeForm.description')}
              validate={[validator.required]}
              disabled={this.props.readOnly || this.isTemplate()}
            />
          </div>

          {this.state.isTemplate && (
            <div className="col-xs-12" style={{ marginTop: '10px' }}>
              <div style={{ textAlign: 'center', fontSize: '14px' }}>
                {getTranslatedString('landlordPortal.noticeForm.wouldYouLikeToAttach')}
              </div>
              <div className="col-sm-12" style={{ textAlign: 'center', margin: '15px 0' }}>
                <BooleanRadioButtons
                  name="attach_management_contact"
                  style={{ width: '187px', margin: 'auto' }}
                  disabled={this.props.readOnly}
                />
                <Field name="attach_management_contact" component={formatter.RenderError} />
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  };

  _renderType = () => {
    if (this.state.isTemplate || this.isTemplate()) return null;
    const { legalNoticesEnabled, readOnly } = this.props;

    const noticeTypes = () => {
      let types = NoticeTypes;
      if (!legalNoticesEnabled) {
        types = types.filter((t) => t.value !== LegalNotice);
      }

      if (!featureEnabled('notice_of_entry_as_notices')) {
        types = types.filter((t) => t.value !== NoticeOfEntryNotice);
      }

      return types;
    };

    const renderSelect = () => {
      return (
        <Field
          name="notice_type"
          component={SelectField}
          validate={[validator.required]}
          floatingLabelText={getTranslatedString('landlordPortal.noticeForm.type')}
          fullWidth
          style={{
            marginTop: '-15px',
            fontSize: '15px',
            textAlign: 'left',
            width: '100%',
          }}
          disabled={readOnly}
        >
          {noticeTypes().map((type) => (
            <MenuItem value={type.value} key={type.value} primaryText={type.label} />
          ))}
        </Field>
      );
    };

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.typeUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            {renderSelect()}
          </div>
        </div>
      </div>
    );
  };

  _renderEffectiveDate = () => {
    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.effectiveDatesUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <p>{getTranslatedString('landlordPortal.noticeForm.selectOneOrMany')}</p>
          </div>
        </div>
        <FieldArray
          name="effective_dates"
          component={NoticeEffectiveDateFields}
          disabled={this.props.readOnly}
        />
      </Fragment>
    );
  };

  _renderAttachments = () => {
    const allowAttachmentTemplate = this.getSelectedTemplateValue('allow_attachment_modify', true);

    const canViewUploadedFile =
      allowAttachmentTemplate || this.props.attachments || !featureEnabled('notice_restrictions');

    let descriptionText = getTranslatedString('landlordPortal.noticeForm.ifYouWould');
    if (!allowAttachmentTemplate) {
      descriptionText = getTranslatedString('landlordPortal.noticeForm.ifYouWouldNoUpload');
    }
    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.attachmentUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <p>{descriptionText}</p>
            {canViewUploadedFile && this._renderAttachment(allowAttachmentTemplate)}
          </div>
        </div>
      </Fragment>
    );
  };

  _renderAttachment = (allowAttachmentTemplate) => {
    return (
      <Field
        name="attachments"
        component={MultiFileDropzone}
        cannotModify={!allowAttachmentTemplate}
        readOnly={this.props.readOnly || !allowAttachmentTemplate}
        acceptedFileTypes={legalNoticeAcceptedFileTypes}
        maxTotalFileSize={config.TOTAL_FILE_SIZE}
        multiple
        changeFormValue={this.props.changeFormValue}
        formName={this.props.form}
      >
        {!this.props.readOnly && allowAttachmentTemplate ? (
          <p style={{ color: colors.BLUE, textAlign: 'center', fontSize: '16px' }}>
            {getTranslatedString('landlordPortal.noticeForm.clickToAddAttachments')}
          </p>
        ) : (
          <span />
        )}
      </Field>
    );
  };

  _renderPhoto = () => {
    const allowImageTemplate = this.getSelectedTemplateValue('allow_image_modify', true);

    const canViewUploadedPhoto =
      allowImageTemplate || this.props.image || !featureEnabled('notice_restrictions');

    let descriptionText = getTranslatedString('landlordPortal.noticeForm.ifYouWouldLikeToDraw');
    if (!allowImageTemplate && this.props.image) {
      descriptionText = getTranslatedString(
        'landlordPortal.noticeForm.ifYouWouldLikeToDrawNoModify'
      );
    } else if (!allowImageTemplate) {
      descriptionText = getTranslatedString(
        'landlordPortal.noticeForm.ifYouWouldLikeToDrawNoUpload'
      );
    }

    return (
      <Fragment>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.noticeForm.photoUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto' }}>
            <p>{descriptionText}</p>
            {canViewUploadedPhoto && (
              <Field
                name="image"
                style={styles.imageField}
                labelText={getTranslatedString('landlordPortal.noticeForm.clickToAddPhoto')}
                component={ReduxDropzone}
                fileValidation=".jpeg, .png, .jpg"
                size={120}
                multiple={false}
                viewFileLink
                cannotModify={!allowImageTemplate}
                disabled={this.props.readOnly || !allowImageTemplate}
                maxFileSize={config.IMAGE_SIZE}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  _renderWarning(isUrgent, deliveryType) {
    // Render a warning that combines if it the template is urgent or if it is for a single unit or single proeprty
    if (deliveryType === 'any' && !isUrgent) return null;
    let warningString = '';
    if (deliveryType === 'single_property') {
      warningString = getTranslatedString('landlordPortal.noticeForm.singlePropertyWarning');
    } else if (deliveryType === 'single_unit') {
      warningString = getTranslatedString('landlordPortal.noticeForm.singleUnitWarning');
    }
    return (
      <div className="row" style={{ padding: '20px 10px 0' }}>
        <p style={{ textAlign: 'center' }}>
          {(featureEnabled('notice_restrictions') || isUrgent) && (
            <i className="em em-warning" style={{ marginBottom: '16px' }} />
          )}
          <br />
          {isUrgent && (
            <TenantResidentVerbiageHelper
              translatedTenant={getTranslatedString(
                'landlordPortal.noticeForm.thisTemplateHasBeenMarkedTenant'
              )}
              translatedResident={getTranslatedString(
                'landlordPortal.noticeForm.thisTemplateHasBeenMarkedResident'
              )}
            />
          )}{' '}
          {featureEnabled('notice_restrictions') && warningString}
        </p>
      </div>
    );
  }
}

let ConnectedNoticeForm = compose(
  connect(
    (state, ownProps) => {
      return {
        form: ownProps.formName,
        notice_template_id: deepDiver(state, `form.${ownProps.formName}.values.notice_template_id`),
        notice_type: deepDiver(state, `form.${ownProps.formName}.values.notice_type`),
        image: deepDiver(state, `form.${ownProps.formName}.values.image`),
        attachments: deepDiver(state, `form.${ownProps.formName}.values.attachments`),
        canOnlySendByNoticeTemplate: state.userTypes.canOnlySendByNoticeTemplate,
        legalNoticesEnabled:
          featureEnabled('legal_documents_as_notices') &&
          !!state.companyDetails.companyPreferences.enable_tenant_legal_notices,
      };
    },
    {
      changeFormValue: change,
    }
  ),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
    initialValues: {
      notice_template_id: 'none',
      notice_type: null,
      cotenants: [],
      attachments: [],
      attach_management_contact: false,
      urgent: false,
      properties: [],
      units: [],
      floors: [],
      risers: [],
    },
  })
)(NoticeForm);

export default ConnectedNoticeForm;
